export default "__VITE_ASSET__be034d2d__"